let Flyer = function () {
    let isModalOpening = false; // To avoid multi click to open the modal

    let _init = function () {
        _loadTcFlyerIframe();
        _bindIframeJavascriptEvents();
        _asyncLoadMyCoupons();
    };

    //****************************************************************
    // TC integration
    //****************************************************************

    let _loadTcFlyerIframe = function () {
        let $iframeContainer = $('#flyer-iframe-container');
        if ($iframeContainer.length) {
            $iframeContainer.empty();
            let flyerUrl = _buildIframeUrl();

            $iframeContainer.append($('<iframe>', {
                src: flyerUrl,
                id: 'tc-flyer-iframe',
                frameborder: 0
            }));
        }
    };

    //****************************************************************
    // Binding
    //****************************************************************

    let _bindIframeJavascriptEvents = function () {
        if (window.addEventListener) {
            window.addEventListener('message', handleMessage, false);
        } else if (window.attachEvent) { // ie8
            window.attachEvent('onmessage', handleMessage);
        }

        function handleMessage(evt) {
            if (evt && typeof evt.data !== 'undefined') {
                let msg = evt.data;
                if (typeof evt.data === 'string') {
                    try {
                        msg = JSON.parse(evt.data);
                    } catch (e) {
                        console.warn(e);
                        return;
                    }
                }

                if (msg.hasOwnProperty('fullscreen')) {
                    _toggleFlyerFullScreen(msg);

                } else if (typeof bindIframe !== 'undefined' && bindIframe === 'true') {
                    if (msg.hasOwnProperty('type') && msg.type === 'ITEM_POP') {
                        _showPromotionDetail(msg);
                    } else if (msg.hasOwnProperty('action') && msg.action === 'confirmation' && msg.hasOwnProperty('message')) {
                        _toggleShoppingListButtonState(msg);
                    }
                }
            }
        }
    };

    let _toggleFlyerFullScreen = function (msg) {
        if (msg.fullscreen) {
            $('body').addClass('flyer-full-page');
        } else {
            $('body').removeClass('flyer-full-page');
        }
    };

    let _showPromotionDetail = function (msg) {
        if (!isModalOpening) {
            isModalOpening = true;
            _callMetroFlyersPromotionDetails(msg);
        }
    };

    let _toggleShoppingListButtonState = function (msg) {
        if (_isFlyerModalOpen()) {
            let confirmationMsg = msg.message;
            let $promotionFlyerModal = $('.modal-flyer-promotion.dishide-target--active');
            if ($promotionFlyerModal.length) {
                let displayedProductSku = $promotionFlyerModal.find('[data-promotion-sku]').attr('data-promotion-sku');
                if (displayedProductSku.length && confirmationMsg.includes(displayedProductSku)) {
                    $promotionFlyerModal.find('button.shoppingListAction ').toggleClass('removeFromList');
                }
            }
        }
    };

    //****************************************************************
    // Ajax
    //****************************************************************

    let _callMetroFlyersPromotionDetails = function (msg) {
        TINK.inProgress($('body'));
        $.ajax({
            url: myPromotionDetailsBlockAjaxUrl,
            type: 'POST',
            headers: {
                'Accept-Language': window['acceptLanguage']
            },
            data: JSON.stringify(msg),
            contentType: 'application/json; charset=utf-8',
            success: function (flyerResult) {
                _showFlyerPromotionDetailsDialog(flyerResult);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.error('Unable to show the product details:' + msg.item.sku);
                }
            },
            complete: function () {
                TINK.stopProgress($('body'));
            }
        });
    };

    let _openMyFavoriteStoreFlyer = function () {
        // Open the modal of confirmation to go back to the favorite store flyer and call the function that clean the cart.
        let selectorModalBox = ".remodal[data-remodal-id='modal-back-to-my-favorite-store']";
        $(selectorModalBox).remodal().open();

        $(document).on('confirmation', selectorModalBox, function () {
            $.ajax({
                url: $(this).data("url-flyer-favorite-store"),
                type: 'POST',
                headers: {
                    'Accept-Language': window['acceptLanguage']
                },
                contentType: 'application/json; charset=utf-8',
                success: function () {
                    if (isInWebview()) {
                        sendWebviewReloadCartToDevice();
                    }
                    window.location.href = _getPageURL();
                },
                error: function (jqXHR) {
                    if (!TINK.redirectIfConflict(jqXHR)) {
                        console.error('Unable to reset the cart to go back to the flyer favorite store');
                        window.location.href = _getPageURL();
                    }
                }
            });
        });
    };

    //****************************************************************
    // Promotion modal
    //****************************************************************

    let _showFlyerPromotionDetailsDialog = function (flyerResult) {
        $('.modal-flyer-promotion').remove();
        let $modalContainer = $('#flyer-promotion-details-modale-container');
        $modalContainer.html(flyerResult);// Add the popup to the HTML page

        // Mandatory for product images in IE
        $modalContainer.refreshImages();

        // Create and open the modale
        //var $flyerModal = $('[data-module=dishide--flyer]');
        var $flyerModal = $('.modal-flyer-promotion');

        if (!isInWebview() || isAuthenticated) {
            $flyerModal.modalActionsExceptions({
                ctaAddToCart: '[onclick*="addProductToCart"]',
                ctaAddToCartStarter: '.addToCartStarter',
                tabClose: '.modal--with-header',
                tabsType: 'modal-flyer'
            });
        }

        //$flyerModal.dishide();
        $modalContainer.remodal().open();

        // To force recreate the modal when opening a product (else remodal will create lot of modals)
        $(document).on('click', $flyerModal.find('[data-tab-close]'), function () {
            isModalOpening = false; // To allow to open new modal on the flyer
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                isModalOpening = false; // To allow to open new modal on the flyer
            }
        });

        _bindShoppingListActions($flyerModal);
        bindProductImageSlider();
        injectSVG();

        // If it's the fallback modal
        if ($('#flyer-fallback').length !== 0) {
            return;
        }

        let $boughtWithProductsContent = $('#slider-aux-products-flyer-bought-with.async-load');
        if ($boughtWithProductsContent.length) {
            $boughtWithProductsContent.asyncLoad(function __enableProductCarousel() {
                let $parentBoughtWith = $('#slider-aux-products-flyer');
                if (!isInWebview() || isAuthenticated) {
                    $parentBoughtWith.modalActionsExceptions({
                        ctaAddToCart: '[onclick*="addProductToCart"]',
                        ctaAddToCartStarter: '.addToCartStarter',
                        tabClose: '.modal--with-header',
                        tabsType: 'modal-flyer'
                    });
                }
                $(document).on('click', $parentBoughtWith.find('[data-tab-close]'), function () {
                    isModalOpening = false;// To allow to open new modale on the flyer
                });

                _resizeProductTilesFlyer();
                $('#aux-products').refreshImages();
                _initAddToCartButtons($('#slider-aux-products-flyer'));
                push_product_list_metrics();
                flyerTileSlick();
            });
        }

        _resizeProductTilesFlyer();
        _initAddToCartButtons();
        push_product_detail_metrics(); // for main product
        push_product_list_metrics(); // for aux products
        pdpCarouselSlick();
        flyerTileSlick();
        showProductsPreviousErrors();

        $flyerModal.find('[data-module~="link-internal--ajax"] ').link_internal({
            $containerScroll: $('.remodal-content'),
            scrollValue: 0
        });
    };

    let _resizeProductTilesFlyer = function () {
        let productTileFlyer = document.getElementsByClassName('deal');
        let maxTileHeight = 0;
        for (let i = 0; i < productTileFlyer.length; i++) {
            let tileHeight = productTileFlyer[i].offsetHeight;

            if (tileHeight > maxTileHeight) {
                maxTileHeight = tileHeight;
            }
        }

        $('.deal').css({'height': maxTileHeight});
    };

    let _initAddToCartButtons = function ($parent) {
        // To show the picture add to cart on images when product is in the cart
        injectSVG();

        // To disable/unable the minus and plus button of the add to cart
        updateQtyIncrementerButtonsState();

        let $addToCartButtons;
        let selectorAddToCartButtons = "#button-addToCart, .button-tile-addToCart, .pt--actions button[aria-labelledby='button-addToCart']";
        if ($parent != null) {
            $addToCartButtons = $(selectorAddToCartButtons, $parent);
        } else {
            $addToCartButtons = $(selectorAddToCartButtons);
        }

        // If we are into the store selector process and we added successfully the product, we have to reload the page (to change the flyer store to the selected store) with a message if all is ok after the add to cart action
        if (!isCartAvailable) {
            window['executeCallBackAddToCartFlyerOnAddToCartFinish'] = function () {
                window.location.href = _getPageURL();
            };
            // used in the add-to-cart js when add to cart process finish in sucess
            $addToCartButtons.data("onaddtocartend", "executeCallBackAddToCartFlyerOnAddToCartFinish");
        }

        // If an error occur during the add to cart process we have to close the lightbox to allow the add to cart process to show the error
        window['executeCallBackAddToCartFlyerOnError'] = function () {
            window.history.pushState({}, document.title, window.location.href.substring(0, window.location.href.indexOf('?')));// Remove URL parameter
        };

        // used in the add-to-cart js when add to cart process fail
        $addToCartButtons.data("onaddtocarterror", "executeCallBackAddToCartFlyerOnError");
    };

    let _bindShoppingListActions = function ($flyerModal) {
        $('button.shoppingListAction', $flyerModal).on('click', function () {
            let $this = $(this);
            let sku = $this.attr('data-promotion-sku');
            if ($this.hasClass('removeFromList')) {
                _removeFromShoppingList(sku);
            } else {
                _addToShoppingList(sku);
            }
        });
    };

    //****************************************************************
    // Shopping list
    //****************************************************************

    let _addToShoppingList = function (sku) {
        document.getElementById('tc-flyer-iframe').contentWindow.postMessage({action: 'addToShoppingList', sku: sku}, tcDomain);
    };

    let _removeFromShoppingList = function (sku) {
        document.getElementById('tc-flyer-iframe').contentWindow.postMessage({action: 'removeFromShoppingList', sku: sku}, tcDomain);
    };


    //****************************************************************
    // Coupons
    //****************************************************************

    let _asyncLoadMyCoupons = function () {
        const $couponsSliderBlock = $('#allCouponsSliderBlock');
        if ($couponsSliderBlock.length) {
            $couponsSliderBlock.asyncLoad(function () {
                if (typeof Coupons !== 'undefined') {
                    Coupons.bindCouponCardActionEvents(flyerCouponClipUrl, flyerCouponUnclipBaseUrl, replaceContainerAfterClipUnclip, closeModalAndRefreshContent);
                    templateSlick($('.couponsListSlick'), 1, 2, 3, false);

                    function replaceContainerAfterClipUnclip(data) {
                        $('#couponsSliderContent').html(data);
                        templateSlick($('.couponsListSlick'), 1, 2, 3, false);
                        Coupons.bindCouponCardActionEvents(flyerCouponClipUrl, flyerCouponUnclipBaseUrl, replaceContainerAfterClipUnclip, closeModalAndRefreshContent);
                    }

                    function closeModalAndRefreshContent(data) {
                        $('#coupon-detail-modal-open').removeClass('in-progress');
                        $('#closeCouponsModal').click();
                        replaceContainerAfterClipUnclip(data)
                    }
                }

                // Initialize detail modals for coupons
                $('[data-remodal-id^="modal-coupon-legal"]').remodal();
            });
        }
    };

    //****************************************************************
    // Util
    //****************************************************************

    let _getPageURL = function () {
        return window.location.protocol + "//" + window.location.host + window.location.pathname;
    };

    let _isFlyerModalOpen = function () {
        return $('.modal-flyer-promotion.dishide-target--active').length;
    };

    let _buildIframeUrl = function () {
        let flyerUrl = tcDomain;
        if (!flyerUrl.match('/$')) {
            flyerUrl += '/';
        }

        // Params used in newsletters by PROD NUM to force a specific page, store or flyer id
        let pageNumberParam = TINK.getParamFromUrl('flyer_page');
        let flyerIdParam = TINK.getParamFromUrl('flyer_id');
        let storeIdParam = TINK.getParamFromUrl('paramStore');

        if (typeof autoSelectFlyerId != 'undefined' && autoSelectFlyerId != null && autoSelectFlyerId.length) {
            flyerUrl += 'flyer/' + autoSelectFlyerId;
        } else if (flyerIdParam) {
            flyerUrl += 'flyer/' + flyerIdParam;
        }

        // Allow storeId override only if no cart. Otherwise, display cart store's flyer.
        if (typeof isFlyerStoreFavoriteStore !== 'undefined' && isFlyerStoreFavoriteStore && storeIdParam) {
            tcStoreId = storeIdParam;
        }

        let iframeUrl = flyerUrl + '?storeId=' + tcStoreId + '&language=' + lang;

        if (pageNumberParam && !isNaN(pageNumberParam)) {
            iframeUrl += '#page=' + pageNumberParam;
        }

        return iframeUrl;
    };

    //****************************************************************
    // Expose for binding
    //****************************************************************

    return {
        init: _init,
        openMyFavoriteStoreFlyer: _openMyFavoriteStoreFlyer
    }
}();

$(function () {
    Flyer.init();
});
